export default __webpack_public_path__ + "static/media/account_circle.c57615b8.svg";